import { createContext, useEffect, useState, useCallback } from "react";

const ContactContext = createContext(null);

const ContactProvider = ({ children }) => {
    const API = process.env.REACT_APP_API_BASE_URL;
    const [contact, setContact] = useState(null);

    const fetchContact = useCallback(async () => {
        try {
            const response = await fetch(`${API}/contact/`);

            if (!response.ok) {
                const errorData = await response.json();
                console.error(errorData?.detail);
            }

            const data = await response.json();
            if (data?.Contact?.length) {
                setContact(data.Contact[0]);
            } else {
                setContact({ email: "", phone_number: ""});
            }
        } catch (error) {
            console.error(error);
        }
    }, [API]);

    useEffect(() => {
        fetchContact();
    }, [fetchContact])

    return (
        <ContactContext.Provider value={contact}>
            {children}
        </ContactContext.Provider>
    );
}

export { ContactContext, ContactProvider };
